import React, {PureComponent} from 'react'
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles/index';
import Paper from '@material-ui/core/Paper';
import InputBase from '@material-ui/core/InputBase';
import IconButton from '@material-ui/core/IconButton';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Avatar from '@material-ui/core/Avatar';
import CardHeader from '@material-ui/core/CardHeader';
import MessageContent from "./MessageContent";

const styles = theme => ({

    avatar: {
        position: 'relative',
    },
    messageRow: {
        display: 'flex',
        marginBottom: theme.spacing(2),
    },
    messageRowLeft: {
        paddingRight: '15%',
    },
    messageRowRight: {
        paddingLeft: '25%',
        justifyContent: 'flex-end'
    },
    messageAvatar: {
        marginTop: 'auto',
        background: '#fff',
        borderRadius: 23,
        padding: 3,
        boxShadow: '0 1px 2px rgba(0, 0, 0, 0.2)',
        marginBottom: 3,
    },
    messageAvatarLeft: {
        borderBottomRightRadius: 3,
    },
    messageAvatarRight: {
        borderBottomLeftRadius: 3,
    },
    messageActivity: {
        marginTop: 'auto',
        color: 'rgba(0, 0, 0, 0.26)',
    },
    messageActivityIconReceived: {
        color: '#2196f3',
    }
});

class Message extends PureComponent {
    state = {messageReceived: false};

    componentWillMount() {
        setTimeout(() => {
            this.setState({messageReceived: true})
        }, 2000)
    }

    render() {
        const {classes, sender, messages, bot, showLoading} = this.props;
        const {messageReceived} = this.state;

        return (<>
                {sender === 'bot' &&
                <div className={classes.messageRow + ' ' + classes.messageRowLeft}>
                    <div className={classes.messageAvatar + ' ' + classes.messageAvatarLeft}>
                        <Avatar alt={bot.name} src={bot.img}
                                className={classes.avatar}/>
                    </div>
                    <MessageContent sender={sender} messages={messages} showLoading={showLoading} bot={bot}/>
                </div>
                }
                {sender === 'self' &&
                <div className={classes.messageRow + ' ' + classes.messageRowRight}>
                    <MessageContent sender={sender} messages={messages} showLoading={showLoading} bot={bot}/>
                    <div className={classes.messageActivity}>
                        <FontAwesomeIcon size={'lg'} icon={['fal', 'check-double']}
                                         className={classes.messageActivityIcon + ' ' + (messageReceived ? classes.messageActivityIconReceived : null)}/>
                    </div>
                </div>}
            </>
        );
    }
}

Message.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Message);
